import { gql } from '@apollo/client';

export const AUTHENTICATION = gql`
  mutation authentication($email: String!, $password: String!, $impersonateId: Int) {
    authentication(email: $email, password: $password, scope: "PUBLIC", impersonateId: $impersonateId) {
      accessToken
      refreshToken
    }
  }
`;
